/** @format */
// eslint-disable-next-line check-file/filename-naming-convention -- Legacy code: do not use as an example.
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { StyledMarketOptionProps } from './types';

/* eslint-disable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
const baseStyles = ({ $showTranslations }: StyledMarketOptionProps) => css`
    padding: var(--layout-spacing-8);
    border-radius: 0.5rem;
    cursor: pointer;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: var(--layout-spacing-12);
    grid-template-rows: 1fr 1fr;
    align-items: center;
    text-decoration: none;
    color: var(--colors-text-secondary);
    transition: background-color;
    transition-duration: 0.2s;
    transition-timing-function: ease-in-out;
    margin-bottom: var(--layout-spacing-8);

    &:hover,
    &:focus {
        background-color: var(--colors-surface-secondary);
    }

    &:last-of-type {
        margin-bottom: 0;
    }

    ${
        !$showTranslations &&
        css`
            padding: var(--layout-spacing-12) var(--layout-spacing-8);

            .market-message {
                grid-row: span 2;
            }
        `
    }

    .flag {
        grid-row: span 2;
    }

    .market-translation {
        ${theme.typography.body_small}
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

export const styles = (props: StyledMarketOptionProps) => css`
    ${baseStyles(props)}
`;
